'use strict';exports.__esModule = true;
var initClientSentry = exports.initClientSentry = function initClientSentry(key) {
  if (!key) {

    return;
  }
  if (!window.Raven) {

    return;
  }
  window.Raven.config(key).install();
};

var setUserData = exports.setUserData = function setUserData(user) {
  if (!user) {
    window.Raven.setUserContext();
  } else {
    window.Raven.setUserContext(user);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/sentry.js
// module id = 1246
// module chunks = 0